import React from "react";

export default function Error () { 
    return ( 
        <div>
            <h2>Что-то пошло не так...</h2>
             <p>Error 404</p>
        </div>
    )
}